// WhatsApp Business Integration
// Replace this number with your actual WhatsApp Business number
const WHATSAPP_NUMBER = "919455622965"; // Format: country code + number (no + or spaces)

export const generateWhatsAppMessage = (productName, size, category, price) => {
  const message = `Hello Cakified! 🎂

I'd like to order:
━━━━━━━━━━━━
🍰 Product: ${productName}
📏 Size: ${size}
💰 Price: ₹${price}
📦 Category: ${category}
━━━━━━━━━━━━

Please confirm availability. Thank you! 😊`;

  return encodeURIComponent(message);
};

export const openWhatsApp = (productName, size, category, price) => {
  const message = generateWhatsAppMessage(productName, size, category, price);
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
  window.open(url, '_blank');
};

export const updateWhatsAppNumber = (newNumber) => {
  console.log('WhatsApp number updated to:', newNumber);
};